declare global {
    interface AppConfigParameters {
        WEBAPP_APP_CAMUNDA_AUTH_WHITELIST: string;
        WEBAPP_APP_AVVIKSSYSTEM_URL: string;
    }
}

export const processApiName = 'prosjekt/process';
export const leverandorApiName = 'leverandor';
export const companyApiName = 'prosjekt/company';
export const okonomiApiName = 'prosjekt/okonomi';
export const prosjektskjemaMimeTypes = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/jpg',
];
